<template>
  <div>
    <v-container>
      <div class="main-title">{{ travelInfo.data.contry }}</div>
      <v-card>
        <a href="http://www.canaan-overseas.com">
          <img :src="`/cannan_api/images/${travelInfo.data.img}`" :alt="travelInfo.data.img">
        </a>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    country: {
      type: String,
      default: 'Eur'
    }
  },
  inject: ['reload'],
  computed: mapGetters({
    travelInfo: 'travelInfo'
  }),
  data() {
    return {}
  },
  watch: {
    country: {
      handler(newValue, oldValue) {
        this.fetchData()
      },
      deep: true
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$store.dispatch('getTravelInfo', {
        id: this.country
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>